import { useMutation, useQueryClient } from 'react-query'

import { userService } from 'src/services/user.service'
import { QUERY_KEYS } from 'src/constants'
import { E2FAMethod, IProfileUserResponse } from 'src/types'

export const useEnable2FATotp = () => {
  const queryClient = useQueryClient()

  return useMutation(
    (code: string) => {
      return userService.enable2FATotp(code)
    },
    {
      onSuccess(data) {
        if (!data) return

        queryClient.setQueryData([QUERY_KEYS.USER], (prev?: IProfileUserResponse) => {
          return prev
            ? { ...prev, two_factor_method: E2FAMethod.Totp }
            : ({} as IProfileUserResponse)
        })
      },
    },
  )
}
